export default "/images/mobile-vactor.png?95060ebbab4e2459326c77fc85126f6c";